<template>
  <div class="card h-100">
    <div class="card-body">
      <h4 class="card-title">
        <div class="row">
          <div class="col-sm-6">
            {{ $t("news.related-news") }}
          </div>
          <div class="col-sm-6 text-right">
            <b-dropdown
              class="chat-noti-dropdown active"
              right
              variant="white"
              v-if="blog[0]"
            >
              <template v-slot:button-content>
                <i class="bx bx-sm bx-dots-vertical-rounded"></i>
              </template>
              <b-dropdown-item class="text-danger">
                <router-link
                  :to="{ name: 'news-target-detail', params: { id: id } }"
                >
                  {{ $t("news.view-news") }}</router-link
                ></b-dropdown-item
              >
              <b-dropdown-item
                @click="deleteNews(id)"
                class="text-danger"
                v-if="
                  id_user === target.id_analys ||
                  id_user === target.manager ||
                  user_type === 'superadmin' ||
                  user_type === 'admin' ||
                  user_type === 'vvip'
                "
                >{{ $t("button.hapus.text") }}</b-dropdown-item
              >
            </b-dropdown>
          </div>
        </div>
      </h4>
      <hr />
      <div class="row">
        <div class="col-sm-3">
          <!-- <div v-if="loading" class="mt-4 mx-auto">
                        <div class="text-center p-5">
                            <div class="spinner-border text-secondary" role="status"></div>
                        </div>
                    </div> -->
          <simplebar style="max-height: 60vh" class="mt-3 pr-4">
            <h5 v-if="source_sort[0]">{{ $t("news.source-news") }}</h5>
            <div v-for="(data, index) in source_sort" :key="index" class="mb-3">
              <div
                class="card bgx h-100 border"
                style="cursor: pointer"
                width="100%"
              >
                <div
                  class="card-body csx"
                  :class="
                    data.source == source_key
                      ? 'border-left border-primary'
                      : ''
                  "
                >
                  <div @click="filterNews(data.source)">
                    <div class="row text-muted">
                      <div class="col-3">
                        <img
                          :src="
                            'https://logo.clearbit.com/https://www.' +
                            data.source
                          "
                          onerror="this.onerror=null;this.src='https://logo.clearbit.com/https://www.google.com';"
                          alt="logo"
                          class="rounded"
                          width="100%"
                        />
                      </div>
                      <div class="col-9">
                        <div class="">
                          <b>{{ data.source }} </b>
                        </div>
                        <div>{{ data.total }} Total News</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </simplebar>
        </div>
        <div class="col-sm-6">
          <div v-if="loading" class="mt-4 mx-auto">
            <div class="text-center p-5">
              <div class="spinner-border text-secondary" role="status"></div>
            </div>
          </div>
          <div
            v-for="(data, index) in news_filter_display"
            :key="index"
            class="mb-4"
          >
            <div class="card bgx h-100">
              <router-link
                :to="{
                  name: 'news-analys',
                  query: { url: data.url },
                }"
                target="_blank"
              >
                <div class="card-body">
                  <div class="row">
                    <div class="col-sm-12">
                      <div class="card h-100">
                        <img
                          src="https://static-exp1.licdn.com/sc/h/244xhbkr7g40x6bsu4gi6q4ry"
                          class="rounded img-fluid"
                          width="100%"
                          v-if="data.image == null"
                        />
                        <img
                          :src="data.image"
                          alt=""
                          srcset=""
                          class="rounded img-fluid"
                          width="100%"
                          v-else
                        />
                      </div>
                    </div>
                    <div class="col-sm-12 mt-2">
                      <h5 class="font-size-15">
                        <span v-if="data.is_hoax == 1"
                          ><b-button variant="outline-primary" size="sm"
                            >Truth</b-button
                          ></span
                        >
                        <span v-if="data.is_hoax == 2"
                          ><b-button variant="outline-danger" size="sm"
                            >Hoax</b-button
                          ></span
                        >
                        <span v-if="data.is_hoax == 3"
                          ><b-button variant="outline-success" size="sm"
                            >Unknown</b-button
                          ></span
                        >
                        {{ data.title }}
                      </h5>
                      <span class="text-secondary">{{
                        formatDate(data.published_at)
                      }}</span>
                      - <span class="text-secondary">{{ data.source }}</span
                      >
                      <!-- <span class="text-white">
                          <span v-if="data.sentiment_analysis === 'positive'">
                            <span class="badge bg-success">Positive</span>
                          </span>
                          <span v-else-if="data.sentiment_analysis === 'negative'">
                            <span class="badge bg-danger">Negative</span>
                          </span>
                          <span v-else>
                            <span class="badge bg-info text-dark">Neutral</span>
                          </span>
                      </span> -->
                      <br />
                      <span
                        :href="data.content"
                        target="_blank"
                        rel="noopener noreferrer"
                        class="text-muted"
                        >{{ data.content.substring(0, 550) }}..</span
                      >
                      Read More
                    </div>
                  </div>
                </div>
              </router-link>
              <div class="card-footer bg-transparent px-5"></div>
            </div>
          </div>
          <div class="div pt-5 pb-5" v-if="!news_filter_display[0] && !loading">
            <p class="text-center">{{ $t("overview.table.all.dnf") }}</p>
            <p class="text-center">
              <router-link :to="'/news?target=' + id">
                <b-button
                  class="btn btn-sm"
                  variant="primary"
                  v-if="
                    id_user === target.id_analys ||
                    id_user === target.manager ||
                    user_type === 'superadmin' ||
                    user_type === 'admin' ||
                    user_type === 'vvip'
                  "
                >
                  <i class="fas fa-search"></i>
                  {{ $t("overview.add-from-internet.text") }}</b-button
                >
              </router-link>
            </p>
          </div>
        </div>
        <div class="col-sm-3 pl-4">
          <simplebar style="max-height: 60vh" class="mt-0">
            <table v-if="news_filter[0]">
              <tr>
                <div
                  v-for="(data, index) in news_filter"
                  :key="index"
                  class="mb-0 px-2"
                >
                  <div class="card bgx h-100">
                    <div class="card-body" style="cursor: pointer">
                      <div class="row" @click="updateDisplay(data)">
                        <div class="col-sm-12">
                          <div class="card h-100">
                            <img
                              src="https://static-exp1.licdn.com/sc/h/244xhbkr7g40x6bsu4gi6q4ry"
                              class="rounded img-fluid"
                              width="100%"
                              v-if="data.image == null"
                            />
                            <img
                              :src="data.image"
                              alt=""
                              srcset=""
                              class="rounded img-fluid"
                              width="100%"
                              v-else
                            />
                          </div>
                        </div>
                        <div class="col-sm-12 mt-2 border-bottom">
                          <span class="text-secondary">{{
                            formatDate(data.published_at)
                          }}</span>
                          - <span class="text-secondary">{{ data.source }}</span
                          ><br />
                          <h5 class="font-size-15">
                            <span v-if="data.is_hoax == 1"
                              ><b-button variant="outline-primary" size="sm"
                                >Truth</b-button
                              ></span
                            >
                            <span v-if="data.is_hoax == 2"
                              ><b-button variant="outline-danger" size="sm"
                                >Hoax</b-button
                              ></span
                            >
                            <span v-if="data.is_hoax == 3"
                              ><b-button variant="outline-success" size="sm"
                                >Unknown</b-button
                              ></span
                            >

                            {{ data.title }}
                          </h5>
                          <!-- <span :href="data.content" target="_blank" rel="noopener noreferrer" class="text-muted">{{data.content.substring(0, 150)}}..</span> -->
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </tr>
            </table>
          </simplebar>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { gmapApi } from "vue2-google-maps";
import TargetService from "@/helpers/target-profile.service";
import NewsService from "@/helpers/news.service.js";
import Swal from "sweetalert2";
import moment from "moment";
import simplebar from "simplebar-vue";
import _ from "lodash";

export default {
  props: ["id_target", "id_analys", "manager", "id_user", "user_type"],

  components: { simplebar },
  data() {
    return {
      id: this.id_target,
      target: "",
      blogSource: [],
      source_sort: [],
      news_filter: [],
      news_filter_display: [],
      source_key: "",
      loading: false,
      loadingnew: false,
      title: "News",
      blog: "",
    };
  },
  methods: {
    getNews() {
      console.log("NEWS GET");
      this.loading = true;
      NewsService.getNewsByID(this.id)
        .then((response) => {
          this.blog = response.data.data;
          this.loading = false;

          let data_blog = response.data.data;
          // console.log(data_blog);
          const grouped = _.groupBy(data_blog, (rep) => rep.source);

          // console.log("group", grouped);

          _.map(_.values(grouped), (arr) => {
            // console.log("arr", arr.length);

            const val = arr[0];
            const data = {
              id: val.id,
              source: val.source,
              logo: val.source_image,
              total: arr.length,
            };
            // console.log('source', data);

            this.blogSource.push(data);
          });

          let sort = _.orderBy(this.blogSource, ["total"], ["desc"]);
          this.source_sort = sort;
          let key = this.source_sort[0].source ?? "";
          this.filterNews(key);
          //   console.log("sort", sort);
        })
        .catch((err) => {
          console.log("d target -> ", err);
          this.loading = false;
        });
    },

    async filterNews(key) {
      this.source_key = key;
      var source_filter = key;
      // console.log('sf', source_filter);
      this.news_filter = [];
      this.blog.forEach((val) => {
        const data_news = {
          id_news: val.id_news,
          id_target: val.id_target,
          source: val.source,
          author: val.author,
          title: val.title,
          url: val.url,
          image: val.image,
          published_at: val.published_at,
          content: val.content,
          sentiment_analysis: val.sentiment_analysis,
          is_analyzed: val.is_analyzed,
          is_hoax: val.is_hoax,
          created_at: val.created_at,
          updated_at: val.updated_at,
        };
        if (val.source == source_filter) {
          // console.log(data_news);
          this.news_filter.push(data_news);
        }
      });

      this.news_filter_display = this.news_filter.slice(0, 1);
    },

    async getTargetDetail() {
      await TargetService.getDetailTarget(this.id)
        .then((response) => {
          this.target = response.data.data;
        })
        .catch((err) => {
          console.log("d target -> ", err);
        });
    },

    deleteNews(id) {
      Swal.fire({
        title: this.$t("button.delete.modal.confirmText[0]"),
        text: this.$t("button.delete.modal.confirmText[1]"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        cancelButtonText: this.$t("button.cancel.text"),
        confirmButtonText: this.$t("button.delete.text"),
      }).then((result) => {
        if (result.isConfirmed) {
          NewsService.deleteNewsTarget(id)
            .then((response) => {
              this.getNews();
              this.news_filter = [];
              this.news_filter_display = [];
              this.blogSource = [];
              Swal.fire({
                position: "top-end",
                icon: "success",
                title: response.data.message,
                showConfirmButton: false,
                timer: 1500,
              });
            })
            .catch((err) => {
              console.log(err);
            });
        }
      });
    },

    updateDisplay(data) {
      this.news_filter_display = [];
      const display = {
        id_news: data.id_news,
        id_target: data.id_target,
        source: data.source,
        author: data.author,
        title: data.title,
        url: data.url,
        image: data.image,
        published_at: data.published_at,
        content: data.content,
        sentiment_analysis: data.sentiment_analysis,
        is_analyzed: data.is_analyzed,
        is_hoax: data.is_hoax,
        created_at: data.created_at,
        updated_at: data.updated_at,
      };
      // console.log(display);
      this.news_filter_display.push(display);
    },

    formatDate(value) {
      return moment(value).format("YYYY-MM-DD, ");
    },
  },
  mounted() {
    this.getTargetDetail();
    this.getNews();
  },
};
</script>

<style scoped>
.csx {
  cursor: pointer;
}
</style>
